import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from '@angular/router';
import jwt_decode from "jwt-decode";
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  isFirmaSubmitLocked,
  isGeneratePdfReady,
  logAutofirmaError,
  releaseFirmaSubmitLock,
} from 'src/app/_helpers/firma-submit.guard';
import { bloquearSiProcedimientoNoActivo } from 'src/app/_helpers/procedimiento-activo.util';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { ClaveService } from 'src/app/_services/clave.service';
import { ClientFirmaLogService } from 'src/app/_services/client-firma-log.service';
import { ProcedimientosService } from "src/app/_services/procedimientos.service";
import { ServicioGeneral } from 'src/app/_services/servicio-general.service';
import { TokenStorageService } from "src/app/_services/token-storage.service";
import { UrlService } from "src/app/_services/urlService";
import { UserService } from 'src/app/_services/user.service';
import { NavService } from 'src/app/boton-listado/boton-listado.component.service';
import { ListadoTramitesEmvsService } from 'src/app/listado/listado-tramites-emvs/listado-tramites-emvs.service';
import { TramiteEmvs } from 'src/app/listado/listado-tramites-emvs/tramite-emvs';
import { SamlRequest } from 'src/app/model/samltoken';
import { NotificationI18nService } from '../../core/util/notification-i18n.service';
declare const AutoScript: any;
declare const Constants: any;
@Component({
  selector: "app-tramites-emvs",
  templateUrl: "./tramites-emvs.component.html",
  styleUrls: ["./tramites-emvs.component.css"],
})
export class TramitesEmvsComponent extends UnsubscribeOnDestroy implements OnInit, OnDestroy {

  filteredProcedimientos: any[] = [];
  procedimientosVisibles: any = [];
  filtrarTexto: string = '';
  Procedimientos: any = [];
  isLoggedIn = false;
  request: TramiteEmvs[] = [];
  user = this.tokenStorageService.getUser()
  userId = this.user["id"];
  tramitesSinFinalizar: TramiteEmvs[] = [];
  tramitesSinFinalizarId: number[] = [];
  tramitesSinFirmar: TramiteEmvs[] = [];
  tramitesSinFirmarId: number[] = [];
  idTramite: number = 0;
  deleteCurrenTramite: TramiteEmvs = {
    id: -1
  }
  signCurrenTramite: TramiteEmvs = {
    id: -1
  }
  display: string = 'none';
  displayFirma: string = 'none';
  procedimientoId: number = 0;
  isInProgress: boolean = false;
  actionProgres: boolean = false;
  firmaResultLocked = false;
  pdfsDownload = [];
  idCurrentPdf: number = 0;
  previousUrl: string;
  subscription: Subscription;
  selectedOpcion: String = 'Firmar con Autofirma';
  mensajeSpinner: string;
  constructor(
    public serviceProcedimientos: ProcedimientosService,
    private tokenStorageService: TokenStorageService,
    private listadoTramitesService: ListadoTramitesEmvsService,
    private _notificationI18n: NotificationI18nService,
    private _router: Router,
    private urlService: UrlService,
    private _servicioGeneral: ServicioGeneral,
    private _navService: NavService,
    private _claveService: ClaveService,
    private spinner: NgxSpinnerService,
    private userService: UserService,
    private _clientFirmaLog: ClientFirmaLogService
  ) {
    super();
  }

  ngOnInit() {
    this.getProcedVisibles();
    this.checkPrevious();

    if (['/formulario-emvs/1', '/formulario-emvs/2', '/formulario-emvs/3'].includes(this.previousUrl)) {
      history.pushState(null, '', location.href);
      window.onpopstate = function () {
        history.go(1);
      };
    }

    this.isLoggedIn = !!this.tokenStorageService.getToken();

    if (this.isLoggedIn) {

      this.getTramiteByUserId();
      this.subscription = this._navService.navItem$

        .pipe(takeUntil(this.destroy$))
        .subscribe(item => {
          this.selectedOpcion = item;
          this.downloadJustificanteFrontP();
        });
    }
  }
  override ngOnDestroy() {
    super.ngOnDestroy();
  }
  checkPrevious() {
    this.previousUrl = this.urlService.getPreviousUrl();
  }

  getTramiteByUserId() {
    this.listadoTramitesService.getTramitesByuserId(this.userId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          for (let item of data) {
            if (item.usuario_id.id == this.userId) {
              if (item.estadoFirma == 'NO_FINALIZADO') {
                this.tramitesSinFinalizarId.push(item.procedimiento_id.id);
                this.tramitesSinFinalizar.push(item);
              }

              if (item.estadoFirma == 'PENDIENTE_DE_FIRMA') {
                this.tramitesSinFirmarId.push(item.procedimiento_id.id);
                this.tramitesSinFirmar.push(item);
              }
            }
          }
        },
        error: (error) => {

        }
      });
  }


  CSV
  downloadJustificanteFront() {

    this.isInProgress = true;
    this.actionProgres = true;
    this.pdfsDownload.push(this.signCurrenTramite.id);
    this.idCurrentPdf = Number(this.signCurrenTramite.id);
    if (this.selectedOpcion == 'Firmar con Autofirma') {
      this.mostrarSpinnerMsg('Solicitando firma...')
      this._servicioGeneral.generatePdf(this.signCurrenTramite.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any) => {
            if (isGeneratePdfReady(data)) {
              this.CSV = data.csv
              this._clientFirmaLog.iniciada(this.idCurrentPdf, 'inicio-tramites-emvs');
              this.singFile(data.file);
            }
            else {
              this._notificationI18n.errorPdfGeneration(data, 5000);
              this.isInProgress = false;
              this.actionProgres = false;
              this.pdfsDownload.splice(this.pdfsDownload.indexOf(this.idCurrentPdf), 1);
              this.ocultarSpinner();
            }
          },
          error: (error) => {
            this._notificationI18n.errorPdfGeneration(error?.error, 5000);
            this.isInProgress = false;
            this.actionProgres = false;
            this.pdfsDownload.splice(this.pdfsDownload.indexOf(this.idCurrentPdf), 1);
            this.ocultarSpinner();
          }
        });

    }
    else {
      this._claveService.iniciaFirma(this.signCurrenTramite.id, 1)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: async (data: SamlRequest) => {
            this.post(data.nodeService, {
              SAMLRequest: data.SamlRequest,
              RelayState: data.RelayState,
            });
          }, error: (error) => {
            this.isInProgress = false;
            this.pdfsDownload.splice(this.pdfsDownload.indexOf(this.idCurrentPdf), 1);
          }
        });
    }
  }
  post(path: string, params: any): void {
    let method = "post";
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }
  public downloadPdf(base64Document, fileName) {
    const source = 'data:application/pdf;base64,' + base64Document;
    const link = document.createElement("a");
    link.href = source;
    link.download = `${fileName}.pdf`
    link.click();
    this.ocultarSpinner()
  }

  public singFile(data): void {
    try {
      AutoScript.cargarAppAfirma();
      AutoScript.setServlets(Constants.URL_BASE_SERVICES + "/afirma-signature-storage/StorageService",
        Constants.URL_BASE_SERVICES + "/afirma-signature-retriever/RetrieveService");
      AutoScript.sign(
        (data != undefined && data != null && data != "") ? data : null,
        "SHA256withRSA",
        "AUTO",
        "",
        this.successCallback,
        this.showErrorCallback
      );
    } catch (e) {
      this._clientFirmaLog.noDisponible(this.idCurrentPdf, 'inicio-tramites-emvs');
      this._notificationI18n.error('NOTIFICATION.MESSAGE.DEBES_DISPONER_DE_LA_APLICACION_AUTOFIRM_PARA_FIRMAR_LOS_TRAMITES_ADMINISTRATIVO')
    }
  }

  public successCallback = (filenameB64, certB64): void => {
    if (isFirmaSubmitLocked(this)) {
      return;
    }
    // filenameB64 es el nombre del fichero de firma codificado en Base 64
    (document.getElementById('certifcado') as HTMLInputElement).value = certB64;
    (document.getElementById('result') as HTMLInputElement).value = filenameB64;
    (document.getElementById('error') as HTMLInputElement).value = '';
    document.forms["firma"].dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }
  public showErrorCallback = (errorType, errorMessage): void => {
    logAutofirmaError(this._clientFirmaLog, this.idCurrentPdf, 'inicio-tramites-emvs', errorType, errorMessage);
    if (isFirmaSubmitLocked(this)) {
      releaseFirmaSubmitLock(this);
      return;
    }
    (document.getElementById('certifcado') as HTMLInputElement).value = '';
    (document.getElementById('result') as HTMLInputElement).value = '';
    (document.getElementById('error') as HTMLInputElement).value = errorMessage + ". Se ha habilitado la opción para firmar con Cl@ve";
    document.forms["firma"].dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }


  resultchange(event: Event): void {
    event.preventDefault();
    if (isFirmaSubmitLocked(this)) {
      return;
    }
    this.firmaResultLocked = true;
    this.ocultarSpinner()
    let base64Document = (document.getElementById('result') as HTMLInputElement).value;
    let errorFirma = (document.getElementById('error') as HTMLInputElement).value;

    if ((errorFirma == '' && base64Document != '')) {
      let certificado = atob((document.getElementById('certifcado') as HTMLInputElement).value);
      if (certificado.includes(this.tokenStorageService.getUser().numero_documento)) {
        this._clientFirmaLog.exito(this.idCurrentPdf, 'inicio-tramites-emvs');
        this.mostrarSpinnerMsg('Subiendo documento firmado...')
        this.listadoTramitesService.updateJustificanteB64({ 'b64Document': base64Document, 'id': this.idCurrentPdf, csv: this.CSV })
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (value) => {
              this._clientFirmaLog.subidaOk(this.idCurrentPdf, 'inicio-tramites-emvs');
              this.serviceProcedimientos
                .getProcedimientoByIdTramite(value.tramite?.id)

                .pipe(takeUntil(this.destroy$))
                .subscribe({
                  next: (procedimiento: any) => {
                    if (procedimiento?.Procedimiento?.id && procedimiento?.Procedimiento?.id != 2)
                      this.downloadPdf(base64Document, 'comprobante_solicitud_tramite');
                  },
                  error: (error) => {
                  },
                });
              releaseFirmaSubmitLock(this);
              this.isInProgress = false;
              this.pdfsDownload.splice(this.pdfsDownload.indexOf(this.idCurrentPdf), 1);
              this._notificationI18n.success('NOTIFICATION.MESSAGE.EL_PDF_SE_HA_FIRMADO_CON_EXITO');
              this.actionProgres = false;
              this.displayFirma = 'none';
              this._router.navigate(['/inicio'], { skipLocationChange: true }).then(() => { this._router.navigate(['/perfil'], { queryParams: { action: 30 } }) });
            },
            error: (err) => {
              console.error(err);
              releaseFirmaSubmitLock(this);
              this._clientFirmaLog.subidaError(this.idCurrentPdf, 'inicio-tramites-emvs', err?.message);
              this.actionProgres = false;
              this.isInProgress = false;
              this.pdfsDownload.splice(this.pdfsDownload.indexOf(this.idCurrentPdf), 1);
              this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_PDF_NO_SE_HA_PODIDO_SUBIR');
              this.displayFirma = 'none';
              this.ocultarSpinner()
            },
          });
      } else {
        releaseFirmaSubmitLock(this);
        this._clientFirmaLog.certificadoInvalido(this.idCurrentPdf, 'inicio-tramites-emvs');
        this.actionProgres = false;
        this.isInProgress = false;
        this.pdfsDownload.splice(this.pdfsDownload.indexOf(this.idCurrentPdf), 1);
        this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_PDF_NO_SE_HA_PODIDO_FIRMAR_EL_CERTIFICADO_NO_COINCIDE_CON_EL_USUARIO');
        this.ocultarSpinner()
      }

    } else {
      releaseFirmaSubmitLock(this);
      this._clientFirmaLog.error(this.idCurrentPdf, 'inicio-tramites-emvs', undefined, errorFirma || 'Firma cancelada o fallida');
      this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_PDF_NO_SE_HA_PODIDO_FIRMAR_POR_FAVOR_COMPRUEBE_QUE_NO_TIENE_ACTIVO_NINGUN_BLO');
      this.isInProgress = false;
      this.actionProgres = false;
      this.ocultarSpinner()
      this.userService
        .clearCurrentTipoFirma()

        .pipe(takeUntil(this.destroy$))
        .subscribe(() => { });
      this.pdfsDownload.splice(this.pdfsDownload.indexOf(this.idCurrentPdf), 1);
    }

  }




  tramiteSinFinalizar(procedimientoId: any): Boolean {
    if (this.tramitesSinFinalizar.find(item => item.procedimiento_id.id == procedimientoId.id && item.custom == procedimientoId.custom)) {
      return true;
    }
    return false;
  }
  tramiteSinFirmar(procedimientoId: any): Boolean {
    if (this.tramitesSinFirmar.find(item => item.procedimiento_id.id == procedimientoId.id && item.custom == procedimientoId.custom)) {
      return true;
    }
    return false;
  }
  resetTramiteAfterSign() {
    if (!this.deleteCurrenTramite.custom) {
      this.listadoTramitesService.deleteTramiteForm(this.signCurrenTramite)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value) => {
            this.signCurrenTramite = this.tramitesSinFirmar.find(item => item.procedimiento_id.id == this.procedimientoId);
            this._router.navigateByUrl(this.signCurrenTramite.procedimiento_id.link_path + '/' + this.signCurrenTramite.procedimiento_id.id);

          },
          error: (err) => {
            console.error(err);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_TRAMITE_NO_SE_HA_PODIDO_ELIMINAR');
          },
        })
    }
    else {
      this.listadoTramitesService.deleteTramiteFormCustom(this.signCurrenTramite)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value) => {
            this.signCurrenTramite = this.tramitesSinFirmar.find(item => item.procedimiento_id.id == this.procedimientoId);
            this._router.navigateByUrl('/formulario/' + this.signCurrenTramite.procedimiento_id.id);

          },
          error: (err) => {
            console.error(err);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_TRAMITE_NO_SE_HA_PODIDO_ELIMINAR');
          },
        })
    }
  }

  resetTramite() {
    if (!this.deleteCurrenTramite.custom) {
      this.listadoTramitesService.deleteTramiteForm(this.deleteCurrenTramite)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value) => {
            this.deleteCurrenTramite = this.tramitesSinFinalizar.find(item => item.procedimiento_id.id == this.procedimientoId);
            this._router.navigateByUrl(this.deleteCurrenTramite.procedimiento_id.link_path + '/' + this.deleteCurrenTramite.procedimiento_id.id);

          },
          error: (err) => {
            console.error(err);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_TRAMITE_NO_SE_HA_PODIDO_ELIMINAR');
          },
        })
    }
    else {
      this.listadoTramitesService.deleteTramiteFormCustom(this.deleteCurrenTramite)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value) => {
            this.deleteCurrenTramite = this.tramitesSinFinalizar.find(item => item.procedimiento_id.id == this.procedimientoId);
            this._router.navigateByUrl('/formulario/' + this.deleteCurrenTramite.procedimiento_id.id);

          },
          error: (err) => {
            console.error(err);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_TRAMITE_NO_SE_HA_PODIDO_ELIMINAR');
          },
        })
    }
  }






  resumeTramite() {
    const tramite = this.deleteCurrenTramite;
    const procId = tramite?.procedimiento_id?.id;
    if (!procId) {
      return;
    }
    this.serviceProcedimientos.getProcedimiento(procId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (procedimiento) => {
          if (bloquearSiProcedimientoNoActivo(procedimiento, this._router, this._notificationI18n, this.user)) {
            return;
          }
          this.listadoTramitesService.tramite = tramite;
          if (!tramite.custom) {
            this._router.navigateByUrl(tramite.procedimiento_id.link_path + '/' + tramite.procedimiento_id.id);
          } else {
            this._router.navigateByUrl('/formulario/' + tramite.procedimiento_id.id);
          }
        },
      });
  }
  getProcedimientos() {
    return this.serviceProcedimientos
      .getProcedimientos()

      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.Procedimientos = data['Procedimiento'];
        this.filteredProcedimientos = [...this.Procedimientos];
      });
  }

  getProcedVisibles() {
    return this.serviceProcedimientos.getProcedVisibles()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.procedimientosVisibles = data['Procedimiento'];
          if (data['ProcedimientoCustom']) this.procedimientosVisibles = this.procedimientosVisibles.concat(data['ProcedimientoCustom']);
          console.log(data);

          this.filteredProcedimientos = [...this.procedimientosVisibles];
        },
        error: (err) => {
        }
      })
  }

  filter() {

    this.filteredProcedimientos = [
      ...this.procedimientosVisibles.filter((datum) =>
        datum.nombre.toLocaleLowerCase().includes(this.filtrarTexto.toLocaleLowerCase())
      ),
    ];
  }

  transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    return items.filter((it) => {
      return it.toLocaleLowerCase().includes(searchText);
    });
  }
  limpiarParametros() {
    this._router.navigate([], {
      queryParams: {
        'rId': null,
        'a': null,
        't': null,
      },
      queryParamsHandling: 'merge'
    });
  }
  downloadJustificanteFrontP() {
    if (this.signCurrenTramite.id != -1 && this.displayFirma == 'block') this.downloadJustificanteFront();
  }

  mostrarSpinnerMsg(mensaje: string) {
    this.mensajeSpinner = mensaje;
    this.spinner.show("tramite_emvs_spinner");
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 60000);
  }
  ocultarSpinner() {
    this.spinner.hide("tramite_emvs_spinner");
  }
  navegaSeccion(ruta: string) {
    this._router
      .navigate(["inicio"], { skipLocationChange: false })
      .then(() => {
        this._router.navigateByUrl('/' + ruta);
      });
  }
  signTramite(procedimientoId: any) {
    this.checkNoExisteTramite(procedimientoId, 'firmar');
  }
  editTramite(procedimientoId: any) {
    this.checkNoExisteTramite(procedimientoId, 'editar');
  }
  navigateNewTramite(procedimientoId: any) {
    this.checkNoExisteTramite(procedimientoId, 'iniciar');
  }
  checkNoExisteTramite(procedimientoId: any, tipo: string) {
    if (procedimientoId.id == 2) {
      let token = this.tokenStorageService.getToken();
      if (token != null) {
        var decodedToken: any = jwt_decode(token);
        var expired = Math.floor(new Date().getTime() / 1000) >= decodedToken.exp;
        if (!expired) {
          this.mostrarSpinnerMsg('Revisando su solicitud');
          this.listadoTramitesService.checkDoesntExistRpsv()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (value) => {
                this.ocultarSpinner();
                if (!value) {
                  this._notificationI18n.warning('NOTIFICATION.MESSAGE.YA_FIGURAN_SUS_DATOS_EN_UNA_SOLICITUD_RPSV_NO_ES_POSIBLE_DAR_DE_ALTA_NUEVAMENTE_');
                }
                else {
                  this.navigateToAction(procedimientoId, tipo);
                }
              },
              error: (err) => {
                this.ocultarSpinner();
                console.error(err);
                this._notificationI18n.error('NOTIFICATION.MESSAGE.HA_OCURRIDO_UN_ERROR_VALIDANDO_LA_EXISTENCIA_DE_UN_TRAMITE_PREVIO_DE_TIPO_RPSV');
              },
            });
        }
        else {
          this.navigateToAction(procedimientoId, tipo);
        }
      }
      else {
        this.navigateToAction(procedimientoId, tipo);
      }
    } else {
      this.navigateToAction(procedimientoId, tipo);
    }

  }
  navigateToAction(procedimientoId: any, tipo: string) {
    switch (tipo) {
      case 'firmar':
        this.displayFirma = 'block';
        this.procedimientoId = procedimientoId.id;
        this.signCurrenTramite = this.tramitesSinFirmar.find(item => item.procedimiento_id.id == procedimientoId.id && item.custom == procedimientoId.custom);
        break;
      case 'editar':
        this.display = 'block';
        this.procedimientoId = procedimientoId.id;
        this.deleteCurrenTramite = this.tramitesSinFinalizar.find(item => item.procedimiento_id.id == procedimientoId.id && item.custom == procedimientoId.custom);
        break;
      case 'iniciar':
        this._router.navigateByUrl(procedimientoId.link_path ? (procedimientoId.link_path + '/' + procedimientoId.id) : ('/formulario/' + procedimientoId.id));
        break;
      default:
        break;
    }
  }

}


